import Lista from './Lista';
import UploadLista from './UploadLista';

export const RelogioDePontoLista = Lista;
export const RelogioDePontoUploadLista = UploadLista;
